export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-low-960-7b6ccefde6110762b1d4485456289bbe.webp";